import Container from "components/__reusable/Container";
import useHelpBackNavigation from "hooks/useHelpBackNavigation";
import { PARENTS_MATERIAL_LINK_MAP } from "config/parentsMaterialLinks";

const ParentsMaterialPage = () => {
  useHelpBackNavigation();

  const getMaterialUrl = (titleJa: string) =>
    PARENTS_MATERIAL_LINK_MAP[titleJa];

  const renderMaterialLink = (titleJa: string, note?: string) => {
    const url = getMaterialUrl(titleJa);

    return (
      <li className="flex gap-2">
        <span className="text-base">■</span>
        <div className="flex-1">
          {url ? (
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-base text-primary underline hover:no-underline font-semibold hover:text-primary/80"
            >
              {titleJa}
            </a>
          ) : (
            <span className="text-base">{titleJa}</span>
          )}
          {note && <p className="text-sm text-gray-600">{note}</p>}
        </div>
      </li>
    );
  };

  return (
    <section className="h-full flex flex-col space-y-3 lg:space-y-5">
      <Container>
        <div className="space-y-6">
          <div>
            <h2 className="text-xl font-bold mb-3">
              新しくイロドキをご利用される方向け
            </h2>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-2">
              配布が<span className="text-red-500">*必須</span>な資料
            </h3>
            <ul className="ml-6 space-y-1">
              {renderMaterialLink(
                "料金プランの選択について",
                "※クラス管理画面での登録用紙発行からも印刷できます。"
              )}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-2">その他、資料</h3>
            <ul className="ml-6 space-y-1">
              {renderMaterialLink(
                "トライアル利用開始のご案内",
                "※ファイル＞ダウンロード＞[Microsoft Word(.docx)]を選択してご利用ください。"
              )}
              {renderMaterialLink("サービス内容のご案内チラシ")}
              {renderMaterialLink("新規登録の手順について")}
              {renderMaterialLink(
                "導入同意書",
                "※ファイル＞ダウンロード＞[Microsoft Word(.docx)]を選択してご利用ください。"
              )}
            </ul>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default ParentsMaterialPage;
